import React  from 'react'
import {FieldViewProps} from "../../../../render/view"
import {BaselineResultType} from "../../../../../gd-modules/gantt-chart/model/const/baseline";

const debug = false
// const debug = "FieldBaseline_View"

export default function FieldBaseline_View(props:FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    debug && console.log(debug, 'render', value, props.model)

    switch (value?.type) {
        case BaselineResultType.NEW     : return <div className="ui5-ico-12 action i5-plus"/>
        case BaselineResultType.AHEAD   : return <div className="ui5-txt-default-small ui5-txt-green">-{value.days}d.</div>
        case BaselineResultType.ON_TIME : return <div className="ui5-ico-12 action i5-done"/>
        case BaselineResultType.BEHIND  : return <div className="ui5-txt-default-small ui5-txt-red">+{value.days}d.</div>
        default                         : return false
    }
}
